import { render } from "./ColorInstall.vue?vue&type=template&id=4bb097b9&scoped=true&ts=true"
import script from "./ColorInstall.vue?vue&type=script&lang=ts"
export * from "./ColorInstall.vue?vue&type=script&lang=ts"

import "./ColorInstall.vue?vue&type=style&index=0&id=4bb097b9&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb097b9"]])

export default __exports__